/**
 * Available categories
 */
export const GameCategoryEnum = {
  SLOTS: 48,
  BLACKJACK: 50,
  ROULETTE: 49,
  VIDEO_POKER: 63,
  TABLE_GAMES: 64,
  BONUS_BUY: 96,
  LIVE_CASINO: 61,
  BACCARAT: 68,
  OTHER_GAMES: 69,
  FAST_PLAY: 85,
  FAVORITE: 'favorite',
  LAST_PLAYED: 'last-played',
  FAVORITE_ID: 67,
  LAST_PLAYED_ID: 65,
  FILTER: 'filter',
  FREE_SPINS: 'free-spins',
  HALLOWEEN_GAMES: 103,
  HALLOWEEN_SLUG: 'halloween-games',
  TOP: 87,
  XMAS_GAMES: 84,
  SUMMER_HITS: 177,
  WORLD_CUP: 187,
  SPINFINITY_QUEST: 101,
  SPINDER: 183,
  EASTER: 'easter',
  SPRING_ELITE: 78,
  CRASH_INSTANT: 85,
} as const;

export type GameCategoryFilterType = typeof GameCategoryEnum[keyof typeof GameCategoryEnum];

export const GamePagePanelTabEnum = {
  LAST_PLAYED: 'last-played',
  FAVORITE: 'favorite',
  POPULAR: 'popular',
  NEW: 'new',
  RANDOM: 'random',
  SEARCH: 'search',
} as const;
